import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { ListSubheader, Divider } from "@mui/material";
import styles from './TaskSectionHeader.module.css';

const TaskSection = (props) => {
  const { children, className, ...other } = props;

  return (
    <>
      <ListSubheader className={cn(styles.subheader, className)} component="div" {...other}>
        {children}
      </ListSubheader>
      <Divider />
    </>
  );
};

TaskSection.propTypes = {
  children: Type.node.isRequired,
  className: Type.string,
};

TaskSection.defaultProps = {
  className: '',
};

export default TaskSection;
